import { Skeleton } from "antd";

// placeholder ต่อ section — reuse grid/card class เดิมให้ตรงตำแหน่งจริง (กัน layout shift)
const KPI_KEYS = ["k1", "k2", "k3", "k4"];
const METRIC_KEYS = ["m1", "m2", "m3"];
const CHART_KEYS = ["c1", "c2", "c3"];

export const SummariesSkeleton = () => (
  <div className="es-skeleton" aria-busy="true" aria-label="กำลังโหลดสรุป">
    <div className="es-summary-block">
      <Skeleton active title paragraph={{ rows: 4 }} />
    </div>
    <div className="es-summary-block">
      <Skeleton active title paragraph={{ rows: 4 }} />
    </div>
  </div>
);

export const KpisSkeleton = () => (
  <div className="es-skeleton es-kpi-grid" aria-busy="true" aria-label="กำลังโหลด KPI">
    {KPI_KEYS.map((key) => (
      <div key={key} className="es-kpi-card">
        <Skeleton.Avatar active shape="square" size="large" />
        <div className="es-kpi-body" style={{ flex: 1 }}>
          <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 1, width: "80%" }} />
        </div>
      </div>
    ))}
  </div>
);

export const MetricsSkeleton = () => (
  <div className="es-skeleton es-metric-grid" aria-busy="true" aria-label="กำลังโหลดข้อมูล">
    {METRIC_KEYS.map((key) => (
      <div key={key} className="es-metric-card">
        <Skeleton active title paragraph={{ rows: 3 }} />
      </div>
    ))}
  </div>
);

export const OperationsSkeleton = () => (
  <div className="es-skeleton es-charts-grid" aria-busy="true" aria-label="กำลังโหลดกราฟ">
    {CHART_KEYS.map((key) => (
      <div key={key} className="es-chart-card">
        <Skeleton active title paragraph={{ rows: 5 }} />
      </div>
    ))}
  </div>
);

// รวมทุก section — เก็บไว้เผื่อใช้แบบโหลดทั้งหน้า
const DashboardSkeleton = () => (
  <>
    <SummariesSkeleton />
    <KpisSkeleton />
    <MetricsSkeleton />
    <OperationsSkeleton />
  </>
);

export default DashboardSkeleton;
